export enum DocumentGenerationStatus {
  Pending = 1,
  Generated = 2,
  Error = 3
}
